import { merchantApiCall } from '../utils/api/merchantApi';

export const getInstallmentBanksAPI = async (transactionId: string) => {
  try {
    const data = await merchantApiCall(
      `gateway/transaction/installment/banks/?id=${transactionId}`
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const getInstallmentPlansAPI = async (
  transactionId: string,
  bankId: string
) => {
  try {
    const data = await merchantApiCall(
      `gateway/transaction/installment/plans/?id=${transactionId}&bank_id=${bankId}`
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const selectInstallmentPlanAPI = async (
  transactionId: string,
  bankId: string,
  planId: number
) => {
  try {
    const data = await merchantApiCall(
      `gateway/transaction/installment/select-plan/?id=${transactionId}&bank_id=${bankId}&plan_id=${planId}`
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const updateTransactionModeAPI = async (
  transactionId: string,
  isInstallment: boolean
) => {
  try {
    const data = await merchantApiCall(
      `gateway/transaction-mode/${transactionId}/`,
      'PUT',
      { is_installment: isInstallment }
    );
    return data;
  } catch (error) {
    return error;
  }
};

// Discount API functions
export const getDiscountBanksAPI = async (transactionId: string) => {
  try {
    const data = await merchantApiCall(
      `gateway/transaction/discount/banks/?id=${transactionId}`
    );
    return data;
  } catch (error) {
    return error;
  }
};

// Apply discount API call
export const applyDiscountAPI = async (
  transactionId: string,
  discountId: string
) => {
  try {
    const data = await merchantApiCall(
      `gateway/transaction/discount/apply/?transaction_id=${transactionId}&discount_id=${discountId}`
    );
    return data;
  } catch (error) {
    return error;
  }
};

// Reset discount API call
export const resetDiscountAPI = async (transactionId: string) => {
  try {
    const data = await merchantApiCall(
      `gateway/transaction/discount/reset/?transaction_id=${transactionId}`
    );
    return data;
  } catch (error) {
    return error;
  }
};

// Utility function to validate if card BIN matches any discount BINs
export const validateDiscountBIN = (
  cardNumber: string,
  discountBanks: any[]
): { isValid: boolean; matchedDiscount: any | null } => {
  if (!discountBanks || discountBanks.length === 0) {
    return { isValid: true, matchedDiscount: null };
  }

  const cleanCardNumber = cardNumber.replace(/\s/g, '');

  for (const bank of discountBanks) {
    // Check if this bank has BINs defined
    if (bank.bins && Array.isArray(bank.bins) && bank.bins.length > 0) {
      // Check if card BIN matches any of the bank's BINs
      const isMatch = bank.bins.some((bin: string) =>
        cleanCardNumber.startsWith(bin)
      );
      if (isMatch) {
        return { isValid: true, matchedDiscount: bank };
      }
    } else {
      // If no BINs are defined for this bank, skip BIN validation for this bank
      // You might want to handle this case differently based on business logic
      continue;
    }
  }

  // If we reach here, no matching BIN was found, but that doesn't mean it's invalid
  // It just means no discount applies
  return { isValid: true, matchedDiscount: null };
};

export const getInstallmentBreakdownAPI = async (pay_load: any) => {
  try {
    const data = await merchantApiCall(
      'gateway/transaction/installment/breakdown/',
      'POST',
      pay_load,
      null,
      false
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const getInstallmentCalculationAPI = async (
  onepay_transaction_id: string,
  installment_plan_id: string,
  bank_id: string
) => {
  try {
    const data = await merchantApiCall(
      `gateway/transaction/installment/calculation/?id=${onepay_transaction_id}&plan_id=${installment_plan_id}&bank_id=${bank_id}`
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const getInstallmentSubmitAPI = async (pay_load: any) => {
  try {
    const data = await merchantApiCall(
      'gateway/transaction/installment/submit/',
      'POST',
      pay_load,
      null,
      false
    );
    return data;
  } catch (error) {
    return error;
  }
};

export const getInstallmentFinalizeAPI = async (pay_load: any) => {
  try {
    const data = await merchantApiCall(
      'gateway/transaction/installment/finalize/',
      'POST',
      pay_load,
      null,
      false
    );
    return data;
  } catch (error) {
    return error;
  }
};
